import React from "react"
import ReactDOM from "react-dom/client"
import * as Sentry from "@sentry/react"
import App from "./App"
import {DefaultErr} from "./components/Err/Err"

export const envName = process.env.ENV_NAME
export const baseDocumentTitle = document.title
export const documentTitle = document.title + " - " + envName
export const reCaptchaSiteKey = process.env.GOOGLE_RECAPTCHA_SITE_KEY

if (envName != null) document.title = documentTitle

if (envName && envName !== "Local") {
	Sentry.init({
		dsn: "https://a42459956f854a55bdaec62a2296162d@o1071400.ingest.sentry.io/6070239",
		integrations: [Sentry.browserTracingIntegration()],
		environment: envName,
		denyUrls: [
			// Browser extensions (Chrome, Firefox, etc.)
			/extensions\//i,
			/^chrome:\/\//i,
			/^moz-extension:\/\//i,

			// Ad blockers / privacy tools
			/blocker/i,
			/adguard/i,

			// Known third-party CDNs
			/google-analytics\.com/i,
			/googletagmanager\.com/i,
			/zdassets\.com/i,
		],
	})
}

const root = ReactDOM.createRoot(document.getElementById("app") as HTMLElement)
root.render(
	<Sentry.ErrorBoundary fallback={<DefaultErr />}>
		<App />
	</Sentry.ErrorBoundary>
)

if (module.hot) module.hot.accept()

initWhiteLabelScript(envName)

function initWhiteLabelScript(envNameRaw?: string) {
	const whiteLabelScriptSrc: Record<string, string> = {
		Sandbox: "https://ui.s.unit.sh/release/master/components.js",
		LIVE: "https://ui.unit.co/release/master/components.js",
		Cert: "https://ui.s.unit.sh/release/master/components.js",
		Dev: "https://ui.s.unit.sh/release/master/components.js",
		Local: "http://localhost:3010/components-sandbox.js",
	}

	const envName = envNameRaw && envNameRaw.trim().length > 0 ? envNameRaw : "Local"
	let scriptSrc = whiteLabelScriptSrc[envName]
	if (!scriptSrc) {
		console.warn(`[Unit Dashboard] Unknown ENV_NAME="${envName}". Falling back to Sandbox Unit Elements script.`)
		scriptSrc = whiteLabelScriptSrc.Sandbox
	}

	const whiteLabelScript = document.createElement("script")
	whiteLabelScript.src = scriptSrc
	whiteLabelScript.type = "text/javascript"
	whiteLabelScript.async = true
	whiteLabelScript.onerror = () => {
		if (envName === "Local") {
			console.warn(
				`[Unit Dashboard] Failed to load Unit Elements script from "${scriptSrc}". ` +
					`If you don't have the local Unit Elements dev server running on :3010, ` +
					`we'll fall back to the Sandbox Unit Elements script.`
			)
			const fallback = document.createElement("script")
			fallback.src = whiteLabelScriptSrc.Sandbox
			fallback.type = "text/javascript"
			fallback.async = true
			document.body.append(fallback)
		}
	}
	document.body.append(whiteLabelScript)
}
